var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a4.667 4.667 0 1 1 0 9.333A4.667 4.667 0 0 1 8 0zm0 1.037c-2.032 0-3.666 1.633-3.666 3.63 0 1.996 1.634 3.63 3.666 3.63s3.666-1.634 3.666-3.63c0-1.997-1.634-3.63-3.666-3.63zM5.733 9.333h4.534c.22 0 .4.129.4.287v.184c0 .131-.125.245-.303.277l-1.435.001c-.154.028-.27.118-.297.23l-.268 5.628c-.126.08-.573.08-.74 0l-.309-5.63c-.027-.11-.142-.2-.295-.228H5.634c-.177-.032-.3-.147-.3-.278V9.62c0-.158.178-.287.4-.287z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPar);
export default __webpack_public_path__ + "static/media/par.34c4ced7d727bcefbb87763f94f4169f.svg";
export { ForwardRef as ReactComponent };